// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","Social":"Footer_Social__BxbY8"};